var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformativeEmptyStateCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2222 29.3111c-.6 0-1.1204-.2204-1.5611-.6611C4.2204 28.2092 4 27.6889 4 27.0889V8.5777c0-.3148.1069-.5787.3206-.7916.2137-.213.4785-.3195.7944-.3195.316 0 .5794.1065.7905.3195.2111.213.3167.4768.3167.7916V27.089h14.3111c.3149 0 .5787.1068.7917.3205.213.2138.3195.4786.3195.7945 0 .3159-.1065.5794-.3195.7905-.213.2111-.4768.3167-.7917.3167H6.2222Zm4.4444-4.4444c-.6 0-1.1203-.2204-1.561-.6611-.4408-.4408-.6612-.9611-.6612-1.5611V4.8666c0-.6.2204-1.1203.6611-1.561.4408-.4408.9611-.6612 1.5611-.6612h13.7779c.6 0 1.1203.2204 1.5611.6611.4407.4408.6611.9611.6611 1.5611v17.7779c0 .6-.2204 1.1203-.6611 1.5611-.4408.4407-.9611.6611-1.5611.6611H10.6666Zm0-2.2222h13.7779V4.8666H10.6666v17.7779Z",
    fill: "#8999B1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformativeEmptyStateCopy);
export default __webpack_public_path__ + "static/media/informative-empty-state-copy.14aca175d44a56b7c538bfedf4dccb8f.svg";
export { ForwardRef as ReactComponent };